import { Component } from '@angular/core';

@Component({
  selector: 'app-typing-indicator',
  template: `
    <div class="typing-indicator">
      <span></span>
      <span></span>
      <span></span>
    </div>
  `,
  styles: [`
    .typing-indicator {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 12px 16px;
    }

    .typing-indicator span {
      height: 8px;
      width: 8px;
      background-color: #90a4ae;
      border-radius: 50%;
      display: inline-block;
      animation: typing 1.4s infinite ease-in-out both;
    }

    .typing-indicator span:nth-child(1) {
      animation-delay: -0.32s;
    }

    .typing-indicator span:nth-child(2) {
      animation-delay: -0.16s;
    }

    @keyframes typing {
      0%, 80%, 100% {
        transform: scale(0.6);
        opacity: 0.5;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `]
})
export class TypingIndicatorComponent {}
